import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { common } from 'src/app/app.common';
import { Router, ActivatedRoute } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, FormBuilder, Validators, MaxLengthValidator, } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { QuaTrinhKhenThuongService } from 'src/app/Utils/services/qua-trinh-khen-thuong.service';
import { AllService } from 'src/app/Utils/services/all.service';
import { DataTablesModule } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { formatValidator } from '@angular-devkit/schematics/src/formats/format-validator';
import { forEach } from '@angular-devkit/schematics';
import { timeout } from 'rxjs/operators';
import { AbstractControl } from '@angular/forms';
import * as CanvasJS from './canvasjs.min';
import * as Canvas from './canvasjs.min.js';
import { ExportService } from 'src/app/utils/services/export.service';
export function removeSpaces(control: AbstractControl) {
  if (control && control.value && !control.value.replace(/\s/g, '').length) {
    control.setValue('');
  }
  return null;
}
@Component({
  selector: 'app-qua-trinh-khen-thuong',
  templateUrl: './qua-trinh-khen-thuong.component.html',
  styleUrls: ['./qua-trinh-khen-thuong.component.scss']
})
export class QuaTrinhKhenThuongComponent implements OnInit {
  arrayOne(n: number): any[] {
    return Array(n);
  }
  public com: common
  Token: any
  dataHeader: any = []
  dataTable: any = []
  Nam_hoc_arr: any = []
  dataHe: any = []
  dataKhoa: any = []
  dataKhoaHoc: any = []
  dataChuyenNganh: any = []
  dataLop: any = []
  dataChart: any = []
  listID_lop: string
  chart: any
  isDisplay: any = true
  dataKhoaHoc2:any = []
  dataChuyenNganh2:any = []
  dataLop2:any = []
  filter = new FormGroup({
    Loai_thong_ke: new FormControl(0),
    Hoc_ky: new FormControl(1),
    Nam_hoc: new FormControl((new Date().getFullYear() - 1) + '-' + new Date().getFullYear()),
    ID_he: new FormControl(null),
    ID_khoa: new FormControl(""),
    ID_lop: new FormControl(""),
    ID_chuyen_nganh: new FormControl(""),
    Khoa_hoc: new FormControl(""),
    Hien_thi: new FormControl(0),
    Nhom: new FormControl(0)
  });
  constructor(
    private modalService: NgbModal,
    private QuaTrinhKhenThuongService: QuaTrinhKhenThuongService,
    private AllService: AllService,
    public router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    public exportService: ExportService
  ) { }

  ngOnInit(): void {
    let element, name, arr
    element = document.getElementById('menu1')
    arr = element.className.split(' ')
    name = 'menu-open'
    if (arr.indexOf(name) == -1) {
      element.className += ' ' + name
    }
    var yearNow = new Date().getFullYear() + 4;
    for (var i = 0; i < 10; i++) {
      let Nam_hoc_string = yearNow + '-' + (yearNow + 1);
      let object = {
        value: Nam_hoc_string,
        name: Nam_hoc_string,
      };
      this.Nam_hoc_arr.push(object);
      yearNow--;
    }
    this.com = new common(this.router)
    this.com.CheckLogin();
    var a = this.com.getUserinfo()
    this.Token = a.Token

    this.getList()
  }
  getList() {
    this.spinner.show()
    let IDhe;
    let IDKhoahoc;
    this.AllService.getHe(this.Token).subscribe((z) => {
      this.dataHe = z
      IDhe = z[0].ID_he
      this.filter.patchValue({ ID_he: z[0].ID_he });
      this.AllService.getKhoa(this.Token).subscribe((z) => {
        this.dataKhoa = z
        this.AllService.getKhoaHoc(this.Token).subscribe((z) => {
          this.dataKhoaHoc = z.Data
          this.dataKhoaHoc2 = this.dataKhoaHoc.filter(i => i.ID_he == IDhe);
          this.dataKhoaHoc2 = this.dataKhoaHoc2.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);

          this.AllService.getLop(this.Token).subscribe((z) => {
            this.dataChuyenNganh = z
            this.dataChuyenNganh2 = this.dataChuyenNganh
            this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.ID_he == IDhe);
            this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
            this.dataLop = z
            this.dataLop2 = this.dataLop.filter(i => i.ID_he == IDhe);
          });
          this.spinner.hide()
        });
      });
    });
  }
  changeHe() {
    this.dataKhoaHoc2 = this.dataKhoaHoc.filter(i => i.ID_he == this.filter.value.ID_he);
    this.dataKhoaHoc2 = this.dataKhoaHoc2.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);
    this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
    this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
    this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
  }
  changeKhoa() {
    if (this.filter.value.ID_khoa != "") {
      this.dataKhoaHoc2 = this.dataKhoaHoc.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);
      this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
    } else {
      this.dataKhoaHoc2 = this.dataKhoaHoc.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);
      this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
    }
  }
  changeKhoaHoc() {
    if (this.filter.value.Khoa_hoc != "") {
      this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.Khoa_hoc == parseInt(this.filter.value.Khoa_hoc));
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      this.dataLop2 = this.dataLop2.filter(i => i.Khoa_hoc == parseInt(this.filter.value.Khoa_hoc));
    } else {
      this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
    }

  }
  changeChuyenNganh() {
    if (this.filter.value.ID_chuyen_nganh != "") {
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      if (this.filter.value.Khoa_hoc != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.Khoa_hoc == parseInt(this.filter.value.Khoa_hoc));
      }
      this.dataLop2 = this.dataLop2.filter(i => i.ID_chuyen_nganh == this.filter.value.ID_chuyen_nganh);
    } else {
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      if (this.filter.value.Khoa_hoc != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.Khoa_hoc == parseInt(this.filter.value.Khoa_hoc));
      }
    }
  }
  getData() {
    this.listID_lop = ""
    if (this.filter.value.ID_lop == "") {
      this.dataLop2.forEach(element => {
        this.listID_lop += element.ID_lop + ","
      });
    } else {
      this.listID_lop = this.filter.value.ID_lop
    }
    this.spinner.show();
    this.dataHeader = []
    this.dataTable = []
    let req = {
      "Loai_thong_ke": this.filter.value.Loai_thong_ke,
      "Hoc_ky": this.filter.value.Hoc_ky,
      "Nam_hoc": this.filter.value.Nam_hoc,
      "objID_lop": {
        "ID_lop": this.filter.value.ID_lop == "" ? 0 : this.filter.value.ID_lop,
        "Ten_lop": "",
        "ID_he": 1,
        "ID_khoa": this.filter.value.ID_khoa == "" ? 0 : this.filter.value.ID_khoa,
        "ID_chuyen_nganh": this.filter.value.ID_chuyen_nganh == "" ? 0 : this.filter.value.ID_chuyen_nganh,
        "Khoa_hoc": this.filter.value.Khoa_hoc == "" ? 0 : this.filter.value.Khoa_hoc,
        "Ten_he": "",
        "Ten_khoa": "",
        "Chuyen_nganh": "",
        "Ten_nganh": "",
        "Nien_khoa": "2017-2021",
        "ID_dt": 0,
        "So_sv": 0,
        "Ra_truong": false,
        "ID_nganh": 15,
        "dsID_lop": this.listID_lop,
        "dsID_dt": ""
      },
      "Nhom_thong_ke": this.filter.value.Nhom,
      "ID_he": this.filter.value.ID_he
    }
    this.QuaTrinhKhenThuongService.getList(req, this.Token).subscribe((z) => {
      this.dataHeader = z.Header
      this.dataTable = z.Data
      this.spinner.hide();

    });
  }
  getDataChart() {
    this.listID_lop = ""
    if (this.filter.value.ID_lop == "") {
      this.dataLop2.forEach(element => {
        this.listID_lop += element.ID_lop + ","
      });
    } else {
      this.listID_lop = this.filter.value.ID_lop
    }
    this.dataChart = []
    this.spinner.show()
    let req = {
      "Loai_thong_ke": this.filter.value.Loai_thong_ke,
      "Hoc_ky": this.filter.value.Hoc_ky,
      "Nam_hoc": this.filter.value.Nam_hoc,
      "objID_lop": {
        "ID_lop": this.filter.value.ID_lop == "" ? 0 : this.filter.value.ID_lop,
        "Ten_lop": "",
        "ID_he": 1,
        "ID_khoa": this.filter.value.ID_khoa == "" ? 0 : this.filter.value.ID_khoa,
        "ID_chuyen_nganh": this.filter.value.ID_chuyen_nganh == "" ? 0 : this.filter.value.ID_chuyen_nganh,
        "Khoa_hoc": this.filter.value.Khoa_hoc == "" ? 0 : this.filter.value.Khoa_hoc,
        "Ten_he": "",
        "Ten_khoa": "",
        "Chuyen_nganh": "",
        "Ten_nganh": "",
        "Nien_khoa": "2017-2021",
        "ID_dt": 0,
        "So_sv": 0,
        "Ra_truong": false,
        "ID_nganh": 15,
        "dsID_lop": this.listID_lop,
        "dsID_dt": ""
      },
      "Nhom_thong_ke": this.filter.value.Nhom,
      "ID_he": this.filter.value.ID_he
    }
    this.QuaTrinhKhenThuongService.getDataChart(req, this.Token).subscribe((z) => {
      let listData = {}

      z.Data.forEach(element => {
        listData = {
          type: "column",
          name: element.Name,
          legendText: element.Name,
          showInLegend: true,
          dataPoints: element.Value
        }
        this.dataChart.push(listData)
      });
      this.chart = new CanvasJS.Chart("chartContainer", {
        animationEnabled: true,
        exportEnabled: true,
        axisY: {
          title: "Tỷ lệ % sinh viên",
          titleFontColor: "#4F81BC",
          lineColor: "#4F81BC",
          labelFontColor: "#4F81BC",
          tickColor: "#4F81BC"
        },
        toolTip: {
          shared: true
        },
        legend: {
          cursor: "pointer",
          reversed: true,
          verticalAlign: "top",
        },
        data: this.dataChart
      });
      this.chart.render();
      this.spinner.hide();
    });
  }

  submit() {
    if (this.filter.value.Hien_thi == 1) {
      this.isDisplay = false
      this.getDataChart()
    } else {
      this.isDisplay = true
      this.getData()
    }

  }
  Excel(){
    this.com = new common(this.router);
    this.com.CheckLogin();
    var a = this.com.getUserinfo();
    
    let req = {
      "Loai_thong_ke": this.filter.value.Loai_thong_ke,
      "Hoc_ky": this.filter.value.Hoc_ky,
      "Nam_hoc": this.filter.value.Nam_hoc,
      "objID_lop": {
        "ID_lop": this.filter.value.ID_lop == "" ? 0 : this.filter.value.ID_lop,
        "Ten_lop": "",
        "ID_he": 1,
        "ID_khoa": this.filter.value.ID_khoa == "" ? 0 : this.filter.value.ID_khoa,
        "ID_chuyen_nganh": this.filter.value.ID_chuyen_nganh == "" ? 0 : this.filter.value.ID_chuyen_nganh,
        "Khoa_hoc": this.filter.value.Khoa_hoc == "" ? 0 : this.filter.value.Khoa_hoc,
        "Ten_he": "",
        "Ten_khoa": "",
        "Chuyen_nganh": "",
        "Ten_nganh": "",
        "Nien_khoa": "2017-2021",
        "ID_dt": 0,
        "So_sv": 0,
        "Ra_truong": false,
        "ID_nganh": 15,
        "dsID_lop": this.listID_lop,
        "dsID_dt": ""
      },
      "Nhom_thong_ke": this.filter.value.Nhom,
      "ID_he": this.filter.value.ID_he
    }
    var r = confirm("File của bạn sẽ được tải xuống trong giây lát!");
    if (r) {
     
      this.spinner.show();            
      this.QuaTrinhKhenThuongService.Excel(req,a.Token)
        .subscribe(z => {
          if (z.Status == 1) {
            this.exportService.exportExcelByte(z.FileData, 'ThongKe');
            this.toastr.success("File đã được tải xuống", "Tác vụ thành công")
            this.spinner.hide();
          }
          else {
            this.toastr.error(z.Message, "Tác vụ thất bại")
            this.spinner.hide();
          }
        });
    };
  }
}
